﻿export default {
    // header
    home: {
        ko: "홈",
        en: "Home",
    },
    trade: {
        ko: "주문",
        en: "Trade",
    },
    wallet: {
        ko: "자산",
        en: "Wallet",
    },
    report: {
        ko: "거래내역",
        en: "Report",
    },
    guide: {
        ko: "공지사항",
        en: "Guide",
    },
    ranking: {
        ko: "순위",
        en: "Ranking",
    },
    depositHeader: {
        ko: "입금",
        en: "Dep",
    },
    withdrawHeader: {
        ko: "출금",
        en: "Wd",
    },
    deposit: {
        ko: "입금",
        en: "Deposit",
    },
    withdraw: {
        ko: "출금",
        en: "Withdraw",
    },
    chatting: {
        ko: "고객센터",
        en: "Chatting",
    },
    setting: {
        ko: "설정변경",
        en: "Setting",
    },
    logout: {
        ko: "로그아웃",
        en: "Logout",
    },
    product: {
        ko: "관심",
        en: "Watch",
    },
    orderbook: {
        ko: "현재가",
        en: "Price",
    },
    chart: {
        ko: "차트",
        en: "Chart",
    },
    reportM: {
        ko: "내역",
        en: "Report",
    },
   

    // password
    tradePassword: {
        ko: "거래비번",
        en: "TradePassword",
    },
    extireAccount: {
        ko: "회원탈퇴",
        en: "Close My account",
    },
    extireAccountConfirm: {
        ko: "회원탈퇴를 하시겠습니까?",
        en: "Are you sure you want to delete your account?",
    },
    extireAccountWarning: {
        ko: "회원의 모든 주문 및 재화정보를 초기화하며, 복구할 수 없으며, 접속이 즉시 해제 됩니다.",
        en: "All of the member’s order history and asset information will be reset and cannot be recovered. Your access will be terminated immediately.",
    },
    extireAccountOK: {
        ko: "회원탈퇴 신청이 되었습니다. 회원정보는 30일 후 자동폐기되며, 기간내 같은 계정으로 가입이 제한됩니다.",
        en: "Your account deletion request has been submitted. Your personal information will be automatically deleted after 30 days, and you will not be able to register again with the same account during this period.",
    },
    acceptAccountOK: {
        ko: "회원 전환 신청이 완료 되었습니다. 기존 모의 정보는 모두 삭제되었고, 재접속 하시면 정식 회원으로 접속합니다",
        en: "Your membership conversion request has been completed. All previous simulation data has been deleted, and you will be logged in as a regular member upon reconnecting.",
    },
    changePsw: {
        ko: "비번변경",
        en: "Change password",
    },
    previousPsw: {
        ko: "이전비밀번호",
        en: "Previous password",
    },
    newPsw: {
        ko: "신규비밀번호",
        en: "New password",
    },
    password: {
        ko: "비밀번호",
        en: "Password",
    },

    // setting
    isOrderSound: {
        ko: "주문소리",
        en: "Order Sound",
    },
    isFilledSound: {
        ko: "체결소리",
        en: "Filled Sound",
    },
    isOrderConfirm: {
        ko: "주문확인",
        en: "Order Confirm",
    },
    showVIAlert: {
        ko: "VI알림",
        en: "VI Alert",
    },
    usePushMessage: {
        ko: "푸시알림",
        en: "Push Msg",
    },
    useAutoLogin: {
        ko: "로그인유지",
        en: "Auto Login",
    },
    useUpdown: {
        ko: "등락율보기",
        en: "Up/Down",
    },
    usePriceBlink: {
        ko: "가격변동깜빡임",
        en: "Price Blink",
    },
    showTicker: {
        ko: "하단주문알림",
        en: "Ticker Alert",
    },
    useSmallFont: {
        ko: "작은폰트사용",
        en: "Small Font",
    },
    useMobileUI: {
        ko: "모바일UI",
        en: "Mobile UI",
    },
    useDesktopUI: {
        ko: "PC UI",
        en: "Desktop UI",
    },
    useOvernight: {
        ko: "오버나잇사용",
        en: "Overnight",
    },
    useOverAlram: {
        ko: "오버나잇알림",
        en: "Overnight Alert",
    },
    useLosscutAlram: {
        ko: "로스컷알림",
        en: "Losscut Alert",
    },
    swipeMove: {
        ko: "슬라이드이동",
        en: "Swipe Move",
    },
    settingTextOne: {
        ko: "※오버나잇을 사용합니다 (오버나잇 수수료가 발생될 수 있습니다)",
        en: "※Overnight enabled (fees may apply)",
    },
    settingTextTwo: {
        ko: "※오버나잇 사용해제 (장마감 때 보유 잔고가 종가로 청산됩니다)",
        en: "※Overnight disabled (balance cleared at close)",
    },
    settingTextThree: {
        ko: "※오버나잇 사용",
        en: "※Overnight On",
    },
    settingTextFour: {
        ko: "※오버나잇사용 해제",
        en: "※Overnight Off",
    },
    settingTextFive: {
        ko: "매입금에 따라 오버나잇 수수료가 부가될 수 있습니다",
        en: "Overnight fee may apply",
    },
    settingTextSix: {
        ko: "장마감 때 보유 잔고가 종가로 청산됩니다",
        en: "Balance cleared at close",
    },

    // button
    cancel: {
        ko: "취소",
        en: "Cancel",
    },
    save: {
        ko: "저장",
        en: "Save",
    },
    send: {
        ko: "전송",
        en: "Send",
    },
    apply: {
        ko: "신청",
        en: "Apply",
    },
    confirm: {
        ko: "확인",
        en: "Confirm",
    },
    orderConfirm: {
        ko: "주문확인",
        en: "Confirm",
    },
    close: {
        ko: "닫기",
        en: "Close",
    },
    update: {
        ko: "정정",
        en: "Update",
    },
    login: {
        ko: "로그인",
        en: "Sign In",
    },
    register: {
        ko: "회원가입",
        en: "Sign Up",
    },
    delete: {
        ko: "삭제",
        en: "Delete",
    },
    showCancelMit: {
        ko: "예약취소",
        en: "Cancel",
    },
    showPostionDialog: {
        ko: "선택청산",
        en: "Liquid",
    },
    liquidPosition: {
        ko: "청산",
        en: "Liquid",
    },
    cancelOrder: {
        ko: "주문취소",
        en: "Cancel",
    },
    labelCancelOrder: {
        ko: "선택하신 {length} 개의 주문을 취소하시겠습니까?",
        en: "Do you want to cancel the selected {length} orders?",
    },
    labelCancelPendingOrder: {
        ko: "선택하신 {length}개의 예약 주문을 취소하시겠습니까?",
        en: "Do you want to cancel the selected {length} pending orders?",
    },

    // tab
    position: {
        ko: "잔고현황",
        en: "Position",
    },
    order: {
        ko: "미체결목록",
        en: "Order",
    },
    mitorder: {
        ko: "예약주문",
        en: "MIT",
    },
    buytab: {
        ko: "매수",
        en: "Buy",
    },
    selltab: {
        ko: "매도",
        en: "Sell",
    },
    moveordertab: {
        ko: "정정/취소",
        en: "Update",
    },
    positionM: {
        ko: "잔고",
        en: "Position",
    },
    orderM: {
        ko: "미체결",
        en: "Order",
    },
    mitorderM: {
        ko: "예약",
        en: "MIT",
    },
    overnight: {
        ko: "오버청산",
        en: "Overnight",
    },
    orderbookTab: {
        ko: "호가",
        en: "Price",
    },
    historyTab: {
        ko: "체결",
        en: "History",
    },
    loginTab: {
        ko: "계정로그인",
        en: "Sign In",
    },
    registerTab: {
        ko: "회원가입",
        en: "Sign Up",
    },

    // loginForm
    userIdTitle: {
        ko: "회원아이디",
        en: "ID",
    },
    userIdPlaceholder: {
        ko: "로그인ID",
        en: "ID",
    },
    loginCheckbox: {
        ko: "아이디저장",
        en: "Remember",
    },
    loginText: {
        ko: "아직 계정이 없나요?",
        en: "Don't have an account yet?",
    },
   
    toRegister: {
        ko: "가입",
        en: "Sign Up",
    },

    // registerForm
    registerText: {
        ko: "이미 계정이 있으신가요?",
        en: "Already have an account?",
    },
    toLogin: {
        ko: "로그인",
        en: "Sign In",
    },
    stepOne: {
        ko: "이용약관",
        en: "Terms",
    },
    stepTwo: {
        ko: "개인정보",
        en: "Privacy",
    },
    stepThree: {
        ko: "기초정보",
        en: "BasicInfo",
    },
    stepFour: {
        ko: "실명정보",
        en: "RealName",
    },
    stepFive: {
        ko: "회원가입 완료",
        en: "Completed",
    },
    agreeCheckOne: {
        ko: "위의 서비스 이용약관에 동의하십니까?",
        en: "Do you agree to the Terms?",
    },
    agreeCheckTwo: {
        ko: "위의 개인정보취급방침에 동의하십니까?",
        en: "Do you agree to the Privacy Policy?",
    },
    checkId: {
        ko: "중복확인",
        en: "Check",
    },
    nicknamePlaceholder: {
        ko: "고객명",
        en: "NickName",
    },
    mobilePlaceholder: {
        ko: "휴대전화번호",
        en: "Mobile",
    },
    sendCode: {
        ko: "인증전송",
        en: "SendCode",
    },
    vertificatePlaceholder: {
        ko: "인증번호",
        en: "Vertificate",
    },
    checkCode: {
        ko: "인증하기",
        en: "Check",
    },
    usernamePlaceholder: {
        ko: "이름",
        en: "RealName",
    },
    bankcodePlaceholder: {
        ko: "은행을 선택하세요",
        en: "Choose a bank",
    },
    accountnoPlaceholder: {
        ko: "계좌번호",
        en: "Accountno",
    },
    emailPlaceholder: {
        ko: "이메일주소",
        en: "Email",
    },
    successTitle: {
        ko: "회원가입성공!",
        en: "Successful!",
    },
    successText: {
        ko: "관리자승인 대기중입니다",
        en: "Waiting for administrator approval",
    },
    prevBtn: {
        ko: "이전",
        en: "Prev",
    },
    nextBtn: {
        ko: "다음",
        en: "Next",
    },
    registerBtn: {
        ko: "가입하기",
        en: "Submit",
    },
    depositBtn: {
        ko: "입금신청",
        en: "Deposit",
    },
    withdrawBtn: {
        ko: "출금신청",
        en: "Withdraw",
    },
    creditBtn: {
        ko: "레버리지신청",
        en: "Credit",
    },
    repaymentBtn: {
        ko: "레버리지상환",
        en: "Repayment",
    },
    searchBtn: {
        ko: "검색",
        en: "Search",
    },
    resetBtn: {
        ko: "재설정",
        en: "Reset",
    },


    // wallet
    walletSecCash: {
        ko: "증거금·입출금",
        en: "Margin & Cash",
    },
    walletSecTrade: {
        ko: "매매",
        en: "Trading",
    },
    walletSecEval: {
        ko: "평가",
        en: "Valuation",
    },
    walletSecOvernight: {
        ko: "오버나잇",
        en: "Overnight",
    },
    walletSecFee: {
        ko: "수수료·세금",
        en: "Fees & Tax",
    },
    walletTodayProfit: {
        ko: "오늘 매매손익",
        en: "Today P/L",
    },
    walletTitle: {
        ko: "자산정보",
        en: "Wallet",
    },
    margin: {
        ko: "증거금",
        en: "Margin",
    },
    bonus: {
        ko: "지원금",
        en: "Bonus",
    },
    filledAmount: {
        ko: "매입금",
        en: "Executed Amt",
    },
    tradeable: {
        ko: "매입가능",
        en: "Available",
    },
    evAmount: {
        ko: "평가금액",
        en: "Mkt Value",
    },
    evMargin: {
        ko: "평가증거금",
        en: "V. Margin",
    },
    evProfit: {
        ko: "평가손익",
        en: "Unreal. P/L",
    },
    profit: {
        ko: "매매손익",
        en: "Real. P/L",
    },
    creditAmount: {
        ko: "레버리지",
        en: "CreditAmount",
    },
    losscutLeft: {
        ko: "로스컷여유금",
        en: "LosscutLeft",
    },
    liquidOvernight: {
        ko: "오버청산예상",
        en: "LiquidOvernight",
    },
    needOvernight: {
        ko: "오버필요입금",
        en: "NeedOvernight",
    },
    availWithdraw: {
        ko: "출금가능",
        en: "AvailWithdraw",
    },
    depositCash: {
        ko: "당일입금",
        en: "DepositCash",
    },
    withdrawCash: {
        ko: "당일출금",
        en: "WithdrawCash",
    },
    handleFee: {
        ko: "취급수수료",
        en: "HandleFee",
    },
    availOvernight: {
        ko: "오버나잇가능",
        en: "AvailOvernight",
    },
    overFee: {
        ko: "오버나잇수수료",
        en: "OverFee",
    },
    overFeeM: {
        ko: "오버수수료",
        en: "OverFee",
    },
    buyAmount: {
        ko: "당일매수",
        en: "Buy Amount",
    },
    sellAmount: {
        ko: "당일매도",
        en: "Sell Amount",
    },
    sellTax: {
        ko: "거래세",
        en: "Sell Tax",
    },
    tradeFee: {
        ko: "거래수수료",
        en: "Tr. Fee",
    },
    csOrderFee: {
        ko: "CS수수료",
        en: "CsOrderFee",
    },
    lossLiquidFee: {
        ko: "로스컷주문료",
        en: "LossLiquidFee",
    },
    overLiquidFee: {
        ko: "오버청산주문료",
        en: "OverLiquidFee",
    },
    frozenAmount: {
        ko: "주문동결",
        en: "FrozenAmount",
    },
    commission: {
        ko: "수수료합계",
        en: "Commission",
    },
    

    // guide
    helpEvents: {
        ko: "도움말&이벤트",
        en: "Help&Events",
    },
    notice: {
        ko: "공지사항",
        en: "Notice",
    },

    // orderForm
    limitKind: {
        ko: "지정가",
        en: "Limit",
    },
    marketKind: {
        ko: "시장가",
        en: "Market",
    },
    limitKindM: {
        ko: "지정",
        en: "Limit",
    },
    marketKindM: {
        ko: "시장",
        en: "Market",
    },
    MIT: {
        ko: "예약",
        en: "MIT",
    },
    touchPrice: {
        ko: "터치가",
        en: "Touch",
    },
    limitPrice: {
        ko: "주문가",
        en: "Limit",
    },
    Count: {
        ko: "수량",
        en: "Qty",
    },
    currentAmount: {
        ko: "금액",
        en: "Amt",
    },
    marketPrice: {
        ko: "구분",
        en: "Market",
    },
    activePosition: {
        ko: "매도가능",
        en: "Sellable",
    },
    symbolName: {
        ko: "종목명",
        en: "Stock Name",
    },
    symbolNamePlaceholder: {
        ko: "종목을 선택하세요",
        en: "Select a symbol",
    },
    symbolNamePlaceholderM: {
        ko: "종목선택",
        en: "Symbol",
    },
    orderDesc: {
        ko: "주문번호",
        en: "OrderNo.",
    },
    orderDescM: {
        ko: "주문",
        en: "No.",
    },
    orderDescPlaceholder: {
        ko: "주문번호를 선택하세요",
        en: "Select order No.",
    },
    orderDescPlaceholderM: {
        ko: "주문번호",
        en: "Order No.",
    },
    movePrice: {
        ko: "정정가격",
        en: "Price",
    },
    movePriceM: {
        ko: "정정가",
        en: "Price",
    },
    priceTypeChange: {
        ko: "가격 유형변경",
        en: "Price Type",
    },

    // chart
    openText: {
        ko: "시가",
        en: "Open",
    },
    openTextM: {
        ko: "시",
        en: "Open",
    },
    closeText: {
        ko: "종가",
        en: "Close",
    },
    highText: {
        ko: "고가",
        en: "High",
    },
    highTextM: {
        ko: "고",
        en: "High",
    },
    lowText: {
        ko: "저가",
        en: "Low",
    },
    lowTextM: {
        ko: "저",
        en: "Low",
    },
    volumeText: {
        ko: "거래량",
        en: "Volume",
    },
    volumeTextOB: { // 호가창 정보(시·고·저·상한·하한·거래). 차트 범례는 volumeText(거래량)
        ko: "거래",
        en: "Volume",
    },
    volumeTextM: {
        ko: "거",
        en: "Volume",
    },
    timeText: {
        ko: "시간",
        en: "Time",
    },
    maxText: {
        ko: "상한",
        en: "Max",
    },
    maxTextM: {
        ko: "상",
        en: "Max",
    },
    minText: {
        ko: "하한",
        en: "Min",
    },
    minTextM: {
        ko: "하",
        en: "Min",
    },
    minute: {
        ko: "분",
        en: "M",
    },
    day: {
        ko: "일",
        en: "D",
    },

    // favorite
    favoriteAddTitle: {
        ko: "관심종목관리",
        en: "Watchlist Manage",
    },
    addFavorites: {
        ko: "탭추가",
        en: "Add",
    },

    // orderbook
    sellTitle: {
        ko: "매도",
        en: "Sell",
    },
    amountTitle: {
        ko: "잔량",
        en: "Amount",
    },
    priceTitle: {
        ko: "가격",
        en: "Price",
    },
    buyTitle: {
        ko: "매수",
        en: "Buy",
    },
    priceText: {
        ko: "체결",
        en: "Price",
    },
    
    // product
    searchSymbolPlaceholder: {
        ko: "종목검색 (기업명/코드)",
        en: "Search symbol (name/code)",
    },
    // report
    overnightTab: {
        ko: "오버나잇잔여일",
        en: "Overnight",
    },
    moneyioTab: {
        ko: "입출금내역",
        en: "Moneyio",
    },
    orderTab: {
        ko: "주문내역",
        en: "Order",
    },
    mitOrderTab: {
        ko: "예약내역",
        en: "MitOrder",
    },
    filledTab: {
        ko: "체결내역",
        en: "Filled",
    },
    dailycloseTab: {
        ko: "일일정산내역",
        en: "Dailyclose",
    },
    
    // headers
    // favorite
    headerProSymbol: {
        ko: "종목/코드",
        en: "Symbol",
    },
    headerPrice: {
        ko: "현재가",
        en: "Price",
    }, 
    headerChange: {
        ko: "등락",
        en: "Change",
    }, 
    //overnight
    headerSymbolCode: {
        ko: "종목코드",
        en: "Code",
    },
    headerSymbolCodeM: {
        ko: "코드",
        en: "Code",
    },
    headerSymbolName: {
        ko: "종목명",
        en: "Name",
    },
    headerAllPosition: {
        ko: "총잔고",
        en: "Balance",
    },
    headerLiquidPosition: {
        ko: "청산예정",
        en: "Liquid",
    },
    headerLiquidAmount: {
        ko: "청산매입금",
        en: "Amount",
    },
    headerLiquidReason: {
        ko: "청산사유",
        en: "Reason",
    },
    //position
    headerSymbol: {
        ko: "종목",
        en: "Symbol",
    },
    headerPositionPrice: {
        ko: "체결가",
        en: "PositionPrice",
    },
    headerPositionPriceM: {
        ko: "매입가",
        en: "PositionPrice",
    },
    headerPosition: {
        ko: "보유수",
        en: "Position",
    },    
    headerPositionM: {
        ko: "보유량",
        en: "Position",
    },
    headerPositionAmount: {
        ko: "매입금",
        en: "Executed Amt",
    },
    headerCurrentPrice: {
        ko: "현재가",
        en: "CurrentPrice",
    },
    headerEvProfit: {
        ko: "평가손익",
        en: "Unreal. P/L",
    },
    headerEvAmount: {
        ko: "평가금액",
        en: "Mkt Value",
    },

    //order
    headerSide: {
        ko: "매매",
        en: "Side",
    },
    headerOrderPath: {
        ko: "경로",
        en: "Path",
    },
    headerOrderPrice: {
        ko: "주문가",
        en: "OrderPrice",
    },
    headerOrderQuantity: {
        ko: "주문수",
        en: "OrderQty",
    },
    headerOrderQuantity2: {
        ko: "수량",
        en: "OrderQty",
    },
    headerLeftQuantity: {
        ko: "미체결",
        en: "LeftQty",
    },
    headerOrderAmount: {
        ko: "금액",
        en: "Amount",
    },
    headerOrderTime: {
        ko: "시간",
        en: "Time",
    },
    headerfilledQuantity: {
        ko: "체결수",
        en: "FilledQty",
    },
    headerRequestTime: {
        ko: "시간",
        en: "Time",
    },
    headerTouchPrice: {
        ko: "터치가",
        en: "TouchPrice",
    },
    // report
    headerOrderNo: {
        ko: "주문번호",
        en: "OrderNo.",
    },
    headerOrderPrice2: {
        ko: "체결가",
        en: "OrderPrice",
    },
    headerFilledQuantity2: {
        ko: "잔여수량",
        en: "FilledQty",
    },
    headerFilledQuantity3: {
        ko: "체결",
        en: "FilledQty",
    },
    headerOverLeftDay: {
        ko: "오버나잇잔여일",
        en: "OverLeftDay",
    },
    headerDate: {
        ko: "일자",
        en: "Date",
    },
    headerLastCash: {
        ko: "전일증거금",
        en: "LastCash",
    },
    headerMargin: {
        ko: "마감증거금",
        en: "Margin",
    },
    headerDepositCash: {
        ko: "입금",
        en: "DepositCash",
    },
    headerWithdrawCash: {
        ko: "출금",
        en: "WithdrawCash",
    },
    headerBuyAmount: {
        ko: "매수",
        en: "BuyAmount",
    },
    headerSellAmount: {
        ko: "매도",
        en: "SellAmount",
    },
    headerProfit: {
        ko: "손익",
        en: "Profit",
    },
    headerCommission: {
        ko: "수수료",
        en: "Commission",
    },
    headerAddBonus: {
        ko: "적립지원금",
        en: "AddBonus",
    },
    headerFilledAmount: {
        ko: "잔고매입금",
        en: "FilledAmount",
    },
    headerCreditAmount: {
        ko: "레버리지",
        en: "CreditAmount",
    },
    headerFilledTime: {
        ko: "체결시간",
        en: "FilledTime",
    },
    headerFilledPrice: {
        ko: "체결가",
        en: "FilledPrice",
    },
    headerFilledAmount2: {
        ko: "체결금액",
        en: "FilledAmount",
    },
    headerStatus: {
        ko: "상태",
        en: "Status",
    },
    headerPriceKind: {
        ko: "구분",
        en: "Kind",
    },
    headerReason: {
        ko: "메시지",
        en: "Reason",
    },
    headerReason2: {
        ko: "상세",
        en: "Reason",
    },
    headerProcTime: {
        ko: "처리시간",
        en: "ProcTime",
    },
    headerBankName: {
        ko: "은행명",
        en: "BankName",
    },
    headerAccountNo: {
        ko: "계좌번호",
        en: "AccountNo",
    },
    headerAccountOwner: {
        ko: "계좌번호",
        en: "AccountOwner",
    },
    headerDetail: {
        ko: "상세",
        en: "Detail",
    },
    emptyTitle: {
        ko: "데이터가 없습니다.",
        en: "There is no data.",
    },

    //credit
    creditDialogTitle: {
        ko: "레버리지신청",
        en: "Credit",
    },
    creditAvailCredit: {
        ko: "신청가능",
        en: "AvailCredit",
    },
    creditCreditAmount: {
        ko: "현재사용",
        en: "CreditAmount",
    },
    creditMargin: {
        ko: "증거금",
        en: "Margin",
    },
    creditMoney: {
        ko: "신청금액",
        en: "Money",
    },
    moneyKRW: {
        ko: "원",
        en: "KRW",
    },
    //repayment
    repaymentDialogTitle: {
        ko: "레버리지상환",
        en: "Repayment",
    },
    repaymentCreditAmount: {
        ko: "사용중인레버리지",
        en: "CreditAmount",
    },
    repaymentLossLimitAmount: {
        ko: "로스컷최소증거금",
        en: "LossLimitAmount",
    },
    headerRepaymentCreditAmount: {
        ko: "레버리지금액",
        en: "CreditAmount",
    },
    headerRepaymentRequestTime: {
        ko: "신청시간",
        en: "Time",
    },
    headerRepaymentLosscutLimit: {
        ko: "최소증거금",
        en: "LosscutLimit",
    },
    repaymentSubmitWallet: {
        ko: "상환",
        en: "Submit",
        
    },
    // deposit
    depositDialogTitle: {
        ko: "입금신청",
        en: "Deposit",
    },
    depositAccountMsg: {
        ko: "입금계좌정보",
        en: "Account",
    },
    depositApplyAccount: {
        ko: "입금계좌요청",
        en: "Apply",
    },
    depositAccountOwner: {
        ko: "예금주",
        en: "AccountOwner",
    },
    moneyMKRW: {
        ko: "만원",
        en: "M KRW",
    },
    clearMoney: {
        ko: "초기화",
        en: "Clear",
    },
    depositMemo: {
        ko: "메모",
        en: "Memo",
    },
    // withdraw
    withdrawDialogTitle: {
        ko: "출금신청",
        en: "Withdraw",
    },
    withdrawAccountMsg: {
        ko: "계좌정보",
        en: "Account",
    },
    allMoney: {
        ko: "전체",
        en: "All",
    },
    // ranking
    headerRanking: {
        ko: "순위",
        en: "Rank",
    },
    headerUserName: {
        ko: "이름",
        en: "Name",
    },
    headerRankingProfit: {
        ko: "손익",
        en: "Profit",
    },
    headerRankingRate: {
        ko: "수익률",
        en: "Rate",
    },
    headerSubscribe: {
        ko: "구독",
        en: "Subscribe",
    },
    headerProfitWeek: {
        ko: "주간수익",
        en: "Weekly profit",
    },
    headerRateWeek: {
        ko: "주간수익률",
        en: "Weekly profit(%)",
    },
    headerRankingWeek: {
        ko: "주간순위",
        en: "Weekly rank",
    },
    headerProfitMonth: {
        ko: "월간수익",
        en: "Monthly profit",
    },
    headerRateMonth: {
        ko: "월간수익률",
        en: "Monthly profit(%)",
    },
    headerRankingMonth: {
        ko: "월간순위",
        en: "Monthly rank",
    },
    headerProfitSeason: {
        ko: "분기수익",
        en: "Season profit",
    },
    headerRateSeason: {
        ko: "분기수익률",
        en: "Season profit(%)",
    },
    headerRankingSeason: {
        ko: "분기순위",
        en: "Season Rank",
    },
    headerRankingUserId: {
        ko: "ID",
        en: "ID",
    },
    headerRankingMyName: {
        ko: "내이름",
        en: "MyName",
    },
    headerRankingRankName: {
        ko: "랭커이름",
        en: "Ranker Name",
    },
    headerRankingStatus: {
        ko: "상태",
        en: "Status",
    },
    subscribeStatus: {
        ko: "구독",
        en: "Subscribed",
    },
    subscribeUnStatus: {
        ko: "미구독",
        en: "Unsubscribed",
    },
    loginSuccess: {
        ko: "로그인 성공!",
        en: "Login Success!",
    },
    loginFail: {
        ko: "로그인 실패!",
        en: "Login Fail!",
    },
    needAgreement:
    {
        ko: "이용약관에 동의가 필요합니다",
        en: "Your consent to the terms and conditions",
    },
    needPrivacy:
    {
        ko: "개인정보처리방침 동의가 필요합니다",
        en: "Your consent to the privacy policy",
    },
    needLoginIDRule:
    {
        ko: "ID는 최소4자리 이상 입력하세요",
        en: "Login ID must be at least 4 digits"
    },
    needCheckID:
    {
        ko: "로그인 아이디 중복 체크를 하세요",
        en: "Check the login ID to see if it is duplicated",
    },
    needNickRule:
    {
        ko: "닉네임을 입력하세요",
        en: "Please enter your nickname",
    },
    needLoginID:
    {
        ko: "아이디를 입력하세요",
        en: "Please check your Login ID",
    },
    needPassword:
    {
        ko: "비밀번호를 입력하세요",
        en: "Please check your password",
    },
    needLoginPWRule:
    {
        ko: "비밀번호는 4자리 이상입력하세요",
        en: "Login password must be at least 4 digits"
    },
    needNameRule:
    {
        ko: "이름을 입력하세요",
        en: "Please enter your name",
    },
    needLoginInfo:
    {
        ko: "로그인 정보를 입력하세요",
        en: "Please enter your login information",
    },
    checkIDOK:
    {
        ko: "중복 확인이 되었습니다",
        en: "The Login ID is not duplicated",
    },
    checkIDDup:
    {
        ko: "아이디가 중복됩니다",
        en: "The Login ID is duplicated",
    },
    registSuccess:
    {
        ko: "회원 가입에 성공하였습니다",
        en: "I succeeded in signing up for membership",
    },
    registFail:
    {
        ko: "회원 가입에 실패하였습니다",
        en: "Membership registration failed",
    },
    restError:
    {
        ko: "요청 중에 오류가 발생하였습니다",
        en: "An error occurred during the request",
    },
    FeaturesNotYet:
    {
        ko: "아직 지원하지 않는 기능입니다. 추후 업데이트 예정입니다",
        en: "This feature is not yet supported. It will be updated later",
    },
    notifyOrderMsg:
    {
        ko: "실제 거래가 아닌 교육용 모의투자 시뮬레이터입니다. 투자 학습과 연습을 위한 앱입니다.",
        en: "This is an educational investment simulation app. It is designed for learning and practicing investment skills.",
    },
    cancelOrderConfirm: {
        ko: "주문을 취소하시겠습니까?",
        en: "Are you sure you want to cancel order?"
    },
    cancelResOrderConfirm: {
        ko: "예약 주문을 취소하시겠습니까?",
        en: "Are you sure you want to cancel reserved order?"
    },
    cancelOrdersConfirm: {
        ko: "{count} 개의 주문을 취소하시겠습니까?",
        en: "Are you sure you want to cancel {count} orders?"
    },
    filledMessage: {
        ko: " 체결이 완료 되었습니다",
        en: " has been fully filled"
    },
    canceledMessage: {
        ko: " 취소되었습니다",
        en: " has been canceled"
    },


    needPrice: {
        ko: "주문 가격을 입력하세요",
        en: "Please enter the order price",
    },
    needPriceHigh: {
        ko: "주문 가격이 너무 높습니다",
        en: "The order price is too high",
    },
    needPriceLow: {
        ko: "주문 가격이 너무 낮습니다",
        en: "The order price is too low",
    },
    noSellableQty: {
        ko: "매도 가능한 수량이 없습니다. 기존 주문이 있는지 확인하세요.",
        en: "No sellable quantity available. Please check for existing orders.",
    },

    touchPriceHigh: {
        ko: "터치 가격이 너무 높게 설정되었습니다",
        en: "The touch price is set too high",
    },
    touchPriceLow: {
        ko: "터치 가격이 너무 낮게 설정되었습니다",
        en: "The touch price is set too low",
    },
    needOrderQty: {
        ko: "주문 수량을 입력하세요",
        en: "Please enter the order quantity",
    },
    needOrderAmountOrQty: {
        ko: "주문 금액 혹은 수량이 입력되지 않았습니다",
        en: "The order amount or quantity has not been entered",
    },

    orderLabelLimit: {
        ko: "주문가격",
        en: "Limit",
    },
    orderLabelMarket: {
        ko: "시장가",
        en: "Market",
    },
    orderLabelPrice: {
        ko: "주문가격",
        en: "Price",
    },
    orderLabelQuantity: {
        ko: "주문수량",
        en: "Quantity",
    },
    orderLabelAmount: {
        ko: "주문금액",
        en: "Amount",
    },

    orderNoteAmount: {
        ko: "주문 금액은 현재가 기준으로 계산됩니다",
        en: "The order amount is calculated based on the current price",
    },
    confirmBuy: {
        ko: "매수 하시겠습니까?",
        en: "Do you want to buy?",
    },
    confirmSell: {
        ko: "매도 하시겠습니까?",
        en: "Do you want to sell?",
    },
    noBalance: {
        ko: "현재 잔고가 없습니다",
        en: "No balance available",
    },

    selectOrder: {
        ko: "주문을 선택 하세요",
        en: "Please select an order",
    },
    confirmMarketLiquidation: {
        ko: "보유하신 {name} 잔고를<br/>시장가로 청산하시겠습니까?",
        en: "Confirm liquidation of your {name} holdings<br/>at market price?",
    },

    addFavoriteMsg: {
        ko: "관심종목에 추가하였습니다",
        en: "Added to watchlists",
    },
    delFavoriteMsg: {
        ko: "관심종목에서 삭제하였습니다",
        en: "Removed from watchlists",
    },
    labelLiquid: {
        ko: "종목청산",
        en: "Liquidate",
    },
    labelLiquidPosition: {
        ko: "선택하신 {length} 종목을 청산하시겠습니까?",
        en: "Do you want to liquidate the selected {length} positions?",
    },
    labelLiquidPositionAll: {
        ko: "보유하신 종목을 청산하시겠습니까?",
        en: "Do you want to liquidate the positions?",
    },
    marketStopTrade: {
        ko: "거래정지",
        en: "Halt",
    },
    canNotAfterMarket: {
        ko: "애프터마켓 거래제한",
        en: "After Market Restrictions",
    },
    marketLimitTrade: {
        ko: "거래제한",
        en: "Halt",
    },
    marketLimitBuy: {
        ko: "매수제한",
        en: "Buy",
    },
    marketLimitSell: {
        ko: "매도제한",
        en: "Sell",
    },
    marketLimitOver: {
        ko: "오버제한",
        en: "Over",
    },
    marketLimitCredit: {
        ko: "신용제한",
        en: "Credit",
    },
    favoriteTabLimit: {
        ko: "관심종목 탭은 8개까지 가능합니다",
        en: "The watchlist tab can contain up to 8 items",
    },
    favoriteTabName: {
        ko: "탭 이름이 비어 있습니다",
        en: "The tab name is empty",
    },
    favoriteTabNeed: {
        ko: "관심종목 탭이 최소 하나 있어야 합니다",
        en: "You must have at least one watchlist tab",
    },
    mainSimulDisplay: {
        ko: "/images/head_simul_k.png",
        en: "/images/head_simul_e.png",
    },
};
